import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const NewsStand = (props) => {
    return (
        <div className={'newsstand-section ' + (props.className ? props.className : '')}>
            <h2 className='section-title'>
                <span className='section-title-text'>
                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.newsstand' />
                </span>
            </h2>
            <div className='newsstand-container'>
                {props.DigitalEdition ?
                    <div>
                        <div className='edition-wrap'>
                            <a href={props.DigitalEdition.IssueURL} className='di-img-outer' target={props.DELinkTarget}>
                                <span className='visually-hidden'>{translator.translate('sandhills.tradepubwebsite.mvc.digitaleditions')}</span>
                                <LazyLoadImage src={props.DigitalEdition.CoverImageURL} alt={'Newsstand Preview'} className='newsstand-preview' />
                            </a>
                        </div>
                        <a href={props.DigitalEdition.IssueURL} id='homepage-digital-edition-button' className='button newsstand-button ts-button' target={props.DELinkTarget}>
                            <TranslationText tKey='sandhills.viewdigitaledition' />
                        </a>
                    </div>
                    :
                    <div className='nopub-wrap'>
                        <LazyLoadImage src='/Content/images/newsstand-nopub.jpg' alt='' className='nopub' />
                    </div>}
                <a className='button newsstand-button ts-button' id='homepage-newsstand-button' href={props.NewsstandURL}>
                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.viewnewsstand' />
                </a>
            </div>
        </div>
    );
};

export default NewsStand;